import PropTypes from 'prop-types';
import EditorToolbarStyle from './EditorToolbarStyle';
//
import { requestUploadImage } from '../../service/uploadfile.service';
// ----------------------------------------------------------------------

export const HEADINGS = ['Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'Heading 5', 'Heading 6'];

export function imageHandler() {
  const t = this;
  const input = window.document.createElement('input');

  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.setAttribute('maxSize', '1048576');
  input.click();

  input.onchange = () => {
    const file = input.files[0];
    if (file.size > 1048576) {
      alert("Max file size 1 MB");
      return;
    }

    uploadFiles(file, t.quill);
  };
}

async function uploadFiles(uploadFileObj, quillObj, service = "blog") {
  const now = new Date();
  const path = `images/${now.getFullYear()}/${now.getMonth()}/${now.getDate()}/`;

  const { code, data } = await requestUploadImage(uploadFileObj, path, 800, 800, service);
  if (code === '200') {
    const range = quillObj.getSelection();
    quillObj.insertEmbed(range.index, 'image', data);
  }
}

export function imageHackerthonHandler() {
  const t = this;
  const input = window.document.createElement('input');

  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.setAttribute('maxSize', '1048576');
  input.click();

  input.onchange = () => {
    const file = input.files[0];
    if (file.size > 1048576) {
      alert("Max file size 1 MB");
      return;
    }

    uploadFiles(file, t.quill, "hackerthon");
  };
}

export const formats = [
  'align',
  'background',
  'blockquote',
  'bold',
  'bullet',
  'code',
  'code-block',
  'color',
  'direction',
  'font',
  'formula',
  'header',
  'image',
  'indent',
  'italic',
  'link',
  'list',
  'script',
  'size',
  'strike',
  'table',
  'underline',
  'video',
];

EditorToolbar.propTypes = {
  id: PropTypes.string.isRequired,
  isSimple: PropTypes.bool,
};

export default function EditorToolbar({ id, isSimple, ...other }) {
  return (
    <EditorToolbarStyle {...other}>
      <div id={id}>
        {!isSimple && (<div className="ql-formats">
          <select className="ql-header" defaultValue="">
            {HEADINGS.map((heading, index) => (
              <option key={heading} value={index + 1}>
                {heading}
              </option>
            ))}
            <option value="">Normal</option>
          </select>
        </div>
        )}

        {isSimple && (<div className="ql-formats">
          <select className="ql-header" defaultValue="">
            <option value={4}>
              {'Heading'}
            </option>
            <option value="">Normal</option>
          </select>
        </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-bold" />
          <button type="button" className="ql-italic" />
          <button type="button" className="ql-underline" />
          <button type="button" className="ql-strike" />
        </div>

        {!isSimple && (
          <div className="ql-formats">
            <select className="ql-color" />
            <select className="ql-background" />
          </div>
        )}

        {isSimple && (
          <div className="ql-formats">
            <select className="ql-color" />
          </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-list" value="ordered" />
          <button type="button" className="ql-list" value="bullet" />
          {!isSimple && <button type="button" className="ql-indent" value="-1" />}
          {!isSimple && <button type="button" className="ql-indent" value="+1" />}
        </div>

        {!isSimple && (
          <div className="ql-formats">
            <button type="button" className="ql-script" value="super" />
            <button type="button" className="ql-script" value="sub" />
          </div>
        )}

        <div className="ql-formats">
          <button type="button" className="ql-code-block" />
          <button type="button" className="ql-blockquote" />
        </div>

        <div className="ql-formats">
          <button type="button" className="ql-link" />
          <button type="button" className="ql-image" />
          <button type="button" className="ql-video" />
        </div>
      </div>
    </EditorToolbarStyle>
  );
}
